import httpClient from '@/api/http-client';

const endpoint = 'api/permit-card-counters';

const permitCardCounterService = {
  getCardCounters: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  update: (permitCardCounter) => httpClient.post(`${endpoint}`, permitCardCounter),
};

export default permitCardCounterService;
